import Vue from 'vue'

Vue.filter('number', function (value) {
  if (value === undefined || value === null)
    return 'N/A';
  return `${(+value).toLocaleString("en-US")}`
})
